import React from "react";
import { Link } from "react-router-dom";

const CheckForLink = ({ textToCheck, otherLink, num }) => {


  const formatText = (text) => {
    // Regular expression to match URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;
  
    // Split the text by new lines to preserve the original formatting
    return text.split('\n').map((line, lineIndex) => (
      <React.Fragment key={lineIndex}>
        {line.split(urlRegex).map((part, i) => {
          // If the part matches the URL regex, wrap it in an anchor tag
          if (urlRegex.test(part)) {
            return (
              <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="out-link"
                style={{
                  marginTop: '0.5rem',
                  lineHeight: "100%"
                }}
              >
                <ChopText text={part} num={num} />
              </a>
            );
          }
  
          // Skip empty strings from the split
          if (!part.trim()) return null;
  
          // If 'otherLink' is provided, wrap non-URL parts in a Link component
          if (otherLink) {
            return (
              <Link key={i} className="in-link" to={otherLink}>
                <ChopText text={part} num={num} />
              </Link>
            );
          }
  
          // Otherwise, return the plain text part
          return (
            <span key={i}>
              <ChopText text={part} num={num} />
            </span>
          )
         
        })}
      </React.Fragment>
    ));
  };
  
  


  return (
    <>
      {formatText(textToCheck)}
    </>
  );
};


export default CheckForLink



const ChopText = ({ text, num }) => {
  
  
  return (
    <>
      {text?.length > num ? 
        <>
          {`${text?.slice(0, num)}...`}
        </>
        :
        <>
          {text}
        </>
      }
    </>
  )
}